import React, { useState } from "react";
import "../../styles/info/ParliamentTabs.css";
import legislationImage from "../../assets/infofrombackground_house_structure.png";
import BillProcessSection from "../BillProcessSection";

const ParliamentTabs = () => {
  const [selectedTab, setSelectedTab] = useState("LEGISLATION");

  const renderContent = () => {
    switch (selectedTab) {
      case "LEGISLATION":
        return (
          <div className="tab-content legislation-image">
            <div className="image-container">
              <span className="image-label">Parliament Structure</span>
              <img
                src={legislationImage}
                alt="Parliament Structure and Bill Process"
              />
            </div>
            <div className="text-only-box">
              <h3 className="centered-heading">How a Bill Becomes a Law</h3>
            </div>
            <BillProcessSection />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="parliament-tabs">
      <h1>Australian Parliament</h1>
      <div className="tab-buttons">
        {["LEGISLATION"].map((tab) => (
          <button
            key={tab}
            className={selectedTab === tab ? "active" : ""}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="tab-body">{renderContent()}</div>
    </div>
  );
};

export default ParliamentTabs;
